export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#plus-filled","viewBox":"0 0 18 18"}